import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "It's Just Like Knitting",
  "description": "",
  "published": "2016-08-24T00:00:00.000Z",
  "redirect_from": ["/blog/its-just-like-knitting/swizec/6969"],
  "categories": "lock picking, locks, Opinions, Personal, relaxing",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Knitting is good for you. If you’re young, it relaxes you, relieves your stress, and gives you a creative outlet. If you’re old, it also reduces your cognitive impairment.`}</p>
    <p><a parentName="p" {...{
        "href": "http://well.blogs.nytimes.com/2016/01/25/the-health-benefits-of-knitting/"
      }}>{`There’s a whole New York Times article about it`}</a></p>
    <p>{`When I was 6 or 7, I made half a scarf. I think I decided that it was too hard and too boring and that you can always ask your mum to make a scarf for you.`}</p>
    <p>{`I’m 28 now, and relaxation and stress relief are always welcome. Avoiding cognitive impairment is a big plus, too. But I still think knitting is kind of pointless when artisanal free range scarfs are cheaper than a nice dinner.`}</p>
    <p>{`So I bought a lock picking set and some clear locks instead. It’s kinda like knitting, right?`}</p>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "//imgur.com/v79Kw"
        }}>{`New hobby!`}</a></p>
    </blockquote>
    <p>{`The basic tumbler lock was quick to figure out:`}</p>
    <ol>
      <li parentName="ol">{`Apply pressure with torsion wrench`}</li>
      <li parentName="ol">{`Take any small-enough pick`}</li>
      <li parentName="ol">{`Fiddle around`}</li>
      <li parentName="ol">{`Lock pops open`}</li>
    </ol>
    <p>{`After just a few hours of practice, I can open that one particular lock in about 10 seconds. It's super disconcerting now that I think about it …`}</p>
    <p>{`The other two locks that I’ve got are proving much harder. I’m almost certain the approach should work: apply gentle pressure, fiddle with pins, lock opens.`}</p>
    <p>{`One of them has this weird configuration where the pins are perpendicular to the key plane. This makes all of my lock picks too big to effectively fiddle around. Either they don’t fit inside at all, or they can’t reach deep enough to fiddle the last pin or two.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/08/sideways-pins.gif",
        "alt": "sideways-pins"
      }}></img></p>
    <p>{`The third lock … holy shit, where do I even begin? There are no pins, only notches. Or notch-like things. I don’t know what they’re called.`}</p>
    <p>{`When you insert the key, nothing moves. Then the first half-twist moves some pin-notch-things, and another half-twist moves the other pin-notch-things. This dislodges two metal balls, which in turn allows you to open the lock.`}</p>
    <p>{`The whole lock is super elegant. No springs, no fuss, just a really damn hard lock to pick. I’m sure you could Google for it, but what do you even Google for?`}</p>
    <p>{`All I need now is an endless supply of random locks. Then I, too, can be like Sherlock Holmes.`}</p>
    <p><img parentName="p" {...{
        "src": "https://static2.hypable.com/wp-content/uploads/2015/03/Elementary-season-3-Sherlock-locks.jpg",
        "alt": null
      }}></img></p>
    <p>{`And yes, it `}<em parentName="p">{`is`}</em>{` relaxing. Especially the part where I can’t unlock the front door to our apartment.`}</p>
    <p>{`Yet ?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      